import React, { Component } from 'react';
import $ from 'jquery';
import axios from 'axios';
import qs from 'qs';

export default class History extends Component {

  render() {

      var data = this.props.data;

      axios.defaults.xsrfCookieName = 'csrftoken'
      axios.defaults.xsrfHeaderName = 'X-CSRFToken'

      axios.post('/api/history', qs.stringify({
        "address": window.address,
      })).then(function (response) {
        var histories = response.data.info;
        var active = "";
        if (histories.length === 0) {
            $("#history-table").html("");
            $("#history-indication").html(data.noHistory);
        }

        histories = histories.slice(0, 10);

        $("#history-tbody").html("");
        histories.map(function(history) {
            if (active) {
                active = "";
            } else {
                active = "active";
            }
            $("#history-tbody").append(
                `<tr class=${active}>
                    <th scope="row">${history.date}</th>
                    <td class="word-break">${history.status}</td>
                    <td class="word-break">${history.token}</td>
                    <td class="word-break">${history.amount}</td>
                    <td class="word-break">${history.transactionhash}</td>
                </tr>`
            );
            return null;
        });
      });


    return (

      <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box">

                    <h4 class="header-title m-t-0 m-b-30">{data.history}</h4>
                    <h4 class="header-title m-t-0 m-b-30">We only show the latest 10 outgoing transaction histories. Incoming transaction history will not show up here.</h4>
                    <p class="text-muted font-13 m-b-15" id="history-indication">
                        {data.hereHistory}
                    </p>
                    <p></p>
                    <div class='table-responsive'>
                    <table class="table m-b-0" id="history-table">
                        <thead>
                            <tr>
                                <th>{data.date}</th>
                                <th>{data.status}</th>
                                <th>{data.token}</th>
                                <th>{data.amount}</th>
                                <th>{data.address}</th>
                            </tr>
                        </thead>
                        <tbody id="history-tbody">
                        </tbody>
                    </table>
                    </div>

                </div>
            </div>
        </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/history.js